export default "__VITE_ASSET__49b1ad4c__"